/*
Service functions for user-related API calls
*/

import axios from 'axios';

import { apiResource } from '../../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';
import { apiFetch } from '../../../common/services/apiFetch';
import { UserData } from '..';
export const usersApi = apiResource<UserData>('users');

// Base API URL
// const API_URL = 'http://localhost:8000/api';
const apiBaseUrl = getApiBaseUrl();
export const API_URL = apiBaseUrl;

// Function to handle user login
export const login = async (email: string, password: string) => {
	const response = await axios.post(
		// Login API endpoint, payload, and config
		`${API_URL}/login`,
		{ email, password },
		{
			headers: { 'Content-Type': 'application/json' },
			withCredentials: true,
		}
	);
	// Return the response data
	return response.data;
};

// Function to apiFetch a user by email
export const getUserByEmail = async (email: string) => {
	// Fetch all users and find the one with the matching email
	const token = localStorage.getItem('token');
	const res = await apiFetch(`${API_URL}/users`, {
		headers: { Authorization: `Bearer ${token}` },
	});
	// Handle non-OK responses
	if (!res.ok) {
		throw new Error(`Erreur API: ${res.status}`);
	}
	// Parse the response and search for the user by email
	const data = await res.json();
	const users = data.member;
	if (!users || users.length === 0) {
		throw new Error('Utilisateur non trouvé');
	}
	const user = users.find((u: { email: string }) => u.email === email);
	// Handle case where user is not found
	if (!user) {
		throw new Error('Utilisateur non trouvé');
	}
	// Return the found user
	return user;
};
